'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ADD_TEAM_MEMBER_FORM_FIELDS = exports.ADD_TEAM_MEMBER_FORM_NAME = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // Constants


var _validationConstants = require('../../../../../common/validation/validationConstants');

var ADD_TEAM_MEMBER_FORM_NAME = exports.ADD_TEAM_MEMBER_FORM_NAME = 'addTeamMember';
var ADD_TEAM_MEMBER_FORM_FIELDS = exports.ADD_TEAM_MEMBER_FORM_FIELDS = {
    userEmail: _extends({}, _validationConstants.FIELDS.email, {
        name: 'userEmail',
        hideBeforeSubmit: true
    })
};


//////////////////
// WEBPACK FOOTER
// ./src/client/user/account/team/form/teamFormConstants.js
// module id = 309
// module chunks = 0